import { Injectable } from '@angular/core';
import {HandleErrorService} from './handle-error.service';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ApiService} from '../core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class SitemapService {

  constructor(
    private serviceApi: ApiService,
    private handleError: HandleErrorService
  ) { }

  // generateSitemap(): Observable<any> {
  //   return this.serviceApi.get(`File/sitemap`)
  //     .pipe(
  //       catchError(this.handleError.catchHttpError)
  //     );
  // }
}
